import { StyleSheet } from 'react-native'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  section: {
    flex: 1,
    paddingBottom: 32
  },
  unselect: {
    marginTop: 12,
    borderRadius: 12,
    paddingVertical: 6
  },
  text: {
    color: Colors.blue_two
  },
  title: {
    fontSize: 24,
    paddingBottom: 16,
    fontWeight: 'bold'
  },
  subTitle: theme => ({
    fontSize: 16,
    paddingBottom: 24,
    color: theme.colors.textColorTwo
  }),
  noneSelected: {
    fontSize: 16,
    lineHeight: 18,
    paddingBottom: 32
  },
  bgWhite: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  bottom: {
    marginBottom: 12
  },
  verticalPadding: { paddingVertical: 24 },
  selectedPlan: {
    borderWidth: 2,
    borderRadius: 6,
    borderColor: Colors.blue_two
  },
  planWrapper: {
    borderWidth: 2,
    borderColor: 'transparent'
  },
  optionWrapper: {
    borderWidth: 1,
    borderColor: Colors.warm_grey_two
  },
  roundedBorders: theme => ({
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  centerText: {
    textAlign: 'center',
    marginHorizontal: 'auto'
  },
  optionText: {
    fontSize: 16
  },
  activeOptionText: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  select: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  backBtn: {
    marginTop: 12,
    display: 'flex',
    paddingVertical: 6
  },
  backTxt: {
    fontSize: 16,
    color: Colors.vfRed
  },
  viewCartBanner: {
    marginBottom: 32
  },
  white: {
    color: Colors.white
  },
  cartTitle: {
    fontWeight: 'bold'
  },
  viewCartText: {
    height: 120,
    padding: 16,
    width: '65%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  bottomRow: {
    display: 'flex',
    gap: 4,
    flexDirection: 'row',
    alignItems: 'center'
  },
  containerStyles: { paddingLeft: 0, paddingRight: 0, paddingBottom: 0 },
  body: {
    paddingTop: 32
  },
  cardSubtitle: {
    fontSize: 24,
    paddingBottom: 24
  },
  space: {
    paddingHorizontal: 16
  },
  details: theme => ({
    marginBottom: 48,
    paddingVertical: 16,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  entry: {
    display: 'flex',
    flexDirection: 'row'
  },
  gap: {
    marginRight: 24
  },
  vceSubTitle: {
    paddingBottom: 4
  },
  vceTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingBottom: 16
  },
  flex: {
    flex: 1
  },
  spaceBetween: {
    justifyContent: 'space-between',
    paddingBottom: 4
  },
  vceDivider: {
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: Colors.lightGrey
  },
  bottomPadding: {
    paddingBottom: 16
  }
})

export default styles
